import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const Styled = {
  CallingCodeSplitted: styled(Typography)({
    borderRight: `1px solid #e0e0e0`,
    paddingRight: 10,
    cursor: 'default',
    pointerEvents: 'none',
  }),
}

export default Styled
